import { motion } from 'framer-motion';
import { Package } from 'lucide-react';

const ItemCard = ({ item }) => {
  const imageUrl = item.custom_image_url || item.fetched_image_url || 'https://placehold.co/400x560/1F1F1F/E3350D?text=POKEMAT';
  const isInStock = item.quantity > 0;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{ scale: 1.02 }}
      transition={{ type: 'spring', stiffness: 300 }}
      className="relative group"
      data-testid={`item-card-${item.slot_id}`}
    >
      <div className={`bg-card border border-white/10 rounded-xl overflow-hidden transition-all duration-300 ${
        isInStock ? 'hover:border-primary/50 hover:shadow-[0_0_15px_rgba(227,53,13,0.3)]' : 'opacity-60'
      } holographic-sheen`}>
        
        {/* Badge */}
        <div className="absolute top-2 right-2 z-20">
          <div className={`px-3 py-1 rounded-full text-xs font-semibold ${
            isInStock ? 'bg-green-500/90 text-white' : 'bg-red-500/90 text-white'
          }`} data-testid={`item-status-${item.slot_id}`}>
            {isInStock ? `Skladem: ${item.quantity} ks` : 'Vyprodáno'}
          </div>
        </div>

        {/* Slot ID Badge */}
        <div className="absolute top-2 left-2 z-20">
          <div className="bg-secondary/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold text-accent" data-testid={`item-slot-${item.slot_id}`}>
            {item.slot_id}
          </div>
        </div>

        {/* Image */}
        <div className="aspect-[3/4] overflow-hidden bg-gradient-to-b from-secondary to-black/50">
          <img
            src={imageUrl}
            alt={item.item_name}
            className="w-full h-full object-contain transition-transform duration-300 group-hover:scale-105"
            data-testid={`item-image-${item.slot_id}`}
          />
        </div>

        {/* Content */}
        <div className="p-4 space-y-2">
          <h3 className="font-heading font-semibold text-sm md:text-base line-clamp-2 text-white" data-testid={`item-name-${item.slot_id}`}>
            {item.item_name}
          </h3>
          
          <div className="flex items-center justify-between">
            <span className="text-2xl font-bold text-accent" data-testid={`item-price-${item.slot_id}`}>
              {item.price} Kč
            </span>
            {isInStock && (
              <Package className="w-5 h-5 text-primary" />
            )}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ItemCard;